/* ============================================================
   Christian Catalogue — product page behaviour
   The native <select name="id"> is the single source of truth.
   Chips and swatches drive it; if this script never runs, the
   select is still visible and the form still posts normally.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents, format) {
    var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function initPdp(root) {
    root.querySelectorAll('[data-cx-pdp]').forEach(function (pdp) {
      if (pdp.dataset.cxReady) return;
      pdp.dataset.cxReady = '1';

      var dataNode = pdp.querySelector('[data-cx-product-json]');
      if (!dataNode) return;

      var data;
      try {
        data = JSON.parse(dataNode.textContent);
      } catch (e) {
        return; // leave the no-JS form working rather than half-wiring the UI
      }

      var variants = data.variants || [];
      var select = pdp.querySelector('[data-cx-select]');
      var form = pdp.querySelector('[data-cx-form]');
      var addBtn = pdp.querySelector('[data-cx-submit]');
      var msg = pdp.querySelector('[data-cx-buy-msg]');
      var stock = pdp.querySelector('[data-cx-stock]');
      var priceEl = pdp.querySelector('[data-cx-price]');
      var wasEl = pdp.querySelector('[data-cx-was]');
      var saveEl = pdp.querySelector('[data-cx-save]');

      // Pickers only make sense once JS is running.
      if (select) select.hidden = true;

      function say(text, state) {
        if (!msg) return;
        msg.textContent = text || '';
        if (state) msg.dataset.state = state;
        else delete msg.dataset.state;
      }

      function chosen(kind) {
        var el = pdp.querySelector('[data-cx-opt="' + kind + '"][aria-pressed="true"]');
        return el ? el.dataset.cxVal : null;
      }

  // Colour names must match loosely. The swatch label and the variant option
  // come from the same Liquid source, but casing, spacing and Gray/Grey drift
  // the moment anyone edits an option in Shopify. cx-home.js already
  // normalises; this keeps the product page consistent with it.
  var COLOUR_ALIASES = {
    grey: 'gray', charcoal: 'black', onyx: 'black', ink: 'black',
    ivory: 'white', chalk: 'white',
    sand: 'beige', tan: 'beige', stone: 'beige', khaki: 'beige',
    lightblue: 'sky', powderblue: 'sky', skyblue: 'sky'
  };
  function normColour(v) {
    if (v === null || v === undefined) return '';
    var k = String(v).toLowerCase().replace(/[^a-z0-9]+/g, '');
    return COLOUR_ALIASES[k] || k;
  }
  function sameColour(a, b) { return normColour(a) === normColour(b); }

      function find(colour, size) {
        return variants.filter(function (v) {
          if (colour !== null && !sameColour(v.colour, colour)) return false;
          if (size !== null && v.size !== size) return false;
          return true;
        })[0];
      }

      function setGallery(mediaId) {
        if (!mediaId) return;
        var slide = pdp.querySelector('.cx-gal__slide[data-cx-media="' + mediaId + '"]');
        if (!slide) return;
        pdp.querySelectorAll('.cx-gal__slide').forEach(function (s) {
          s.classList.toggle('is-active', s === slide);
        });
        pdp.querySelectorAll('.cx-gal__thumb').forEach(function (t) {
          t.setAttribute('aria-current', String(t.dataset.cxMedia === String(mediaId)));
        });
      }

      function render() {
        var colour = chosen('colour');
        var size = chosen('size');

        // Grey out sizes that don't exist in the chosen colour.
        pdp.querySelectorAll('[data-cx-opt="size"]').forEach(function (btn) {
          var v = find(colour, btn.dataset.cxVal);
          var ok = !!(v && v.available);
          btn.disabled = !ok;
          if (!ok && btn.getAttribute('aria-pressed') === 'true') {
            btn.setAttribute('aria-pressed', 'false');
            size = null;
          }
        });

        // Mark colours with no stock at all.
        pdp.querySelectorAll('[data-cx-opt="colour"]').forEach(function (btn) {
          var any = variants.some(function (v) {
            return sameColour(v.colour, btn.dataset.cxVal) && v.available;
          });
          btn.classList.toggle('is-gone', !any);
        });

        // Reflect chosen values in the labels.
        pdp.querySelectorAll('[data-cx-current]').forEach(function (el) {
          var kind = el.dataset.cxCurrent;
          el.textContent = chosen(kind) || '';
        });

        var variant = find(colour, size);

        if (variant) {
          if (select) select.value = String(variant.id);
          if (priceEl) {
            priceEl.textContent = money(variant.price, data.money_format);
            priceEl.classList.toggle('cx-pdp__price--sale', !!(variant.compare && variant.compare > variant.price));
          }
          if (wasEl) {
            var onSale = variant.compare && variant.compare > variant.price;
            wasEl.hidden = !onSale;
            if (onSale) wasEl.textContent = money(variant.compare, data.money_format);
          }
          if (saveEl) {
            var save = variant.compare && variant.compare > variant.price
              ? Math.round(((variant.compare - variant.price) / variant.compare) * 100)
              : 0;
            saveEl.hidden = save <= 0;
            if (save > 0) saveEl.textContent = 'Save ' + save + '%';
          }
          setGallery(variant.media_id);

          if (addBtn) {
            addBtn.disabled = !variant.available;
            addBtn.textContent = variant.available
              ? addBtn.dataset.cxLabel || 'Add to cart'
              : 'Sold out';
          }
          if (stock) {
            var dot = stock.querySelector('.cx-buy__dot');
            var txt = stock.querySelector('[data-cx-stock-text]');
            stock.hidden = false;
            if (!variant.available) {
              if (dot) dot.className = 'cx-buy__dot cx-buy__dot--out';
              if (txt) txt.textContent = 'Sold out in this size';
            } else if (variant.qty > 0 && variant.qty <= 10) {
              if (dot) dot.className = 'cx-buy__dot cx-buy__dot--low';
              if (txt) txt.textContent = 'Only ' + variant.qty + ' left';
            } else {
              if (dot) dot.className = 'cx-buy__dot';
              if (txt) txt.textContent = 'In stock, ships in 3–5 business days';
            }
          }

          // Keep the URL shareable without adding history entries.
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
        } else {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.dataset.cxLabel || 'Add to cart';
          }
          if (stock) stock.hidden = true;
        }
      }

      // Wire the pickers.
      pdp.querySelectorAll('[data-cx-opt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var kind = btn.dataset.cxOpt;
          pdp.querySelectorAll('[data-cx-opt="' + kind + '"]').forEach(function (o) {
            o.setAttribute('aria-pressed', 'false');
          });
          btn.setAttribute('aria-pressed', 'true');
          say('');
          render();
        });
      });

      // Thumbnails.
      pdp.querySelectorAll('.cx-gal__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          setGallery(t.dataset.cxMedia);
        });
      });

      // Prev / next.
      function step(dir) {
        var slides = Array.prototype.slice.call(pdp.querySelectorAll('.cx-gal__slide'));
        if (slides.length < 2) return;
        var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        var next = slides[(i + dir + slides.length) % slides.length];
        if (next) setGallery(next.dataset.cxMedia);
      }
      var prev = pdp.querySelector('[data-cx-prev]');
      var nextBtn = pdp.querySelector('[data-cx-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

      // Submit through the cart API, falling back to a normal form post.
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!select || !select.value) return; // let the browser handle it
          var size = chosen('size');
          var hasSizes = pdp.querySelector('[data-cx-opt="size"]') !== null;
          if (hasSizes && !size) {
            e.preventDefault();
            say('Pick a size first', 'error');
            return;
          }

          e.preventDefault();
          say('Adding…');
          if (addBtn) addBtn.disabled = true;

          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }] })
          })
            .then(function (r) {
              if (!r.ok) throw new Error('add');
              return r.json();
            })
            .then(function () {
              say('Added to your cart');
              refreshCart();
            })
            .catch(function () {
              form.submit(); // native post always works
            })
            .then(function () {
              if (addBtn) addBtn.disabled = false;
            });
        });
      }

      // Sticky bar appears once the real buy box scrolls away.
      var sticky = pdp.querySelector('[data-cx-sticky]');
      var anchor = pdp.querySelector('[data-cx-buybox]');
      if (sticky && anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              sticky.classList.toggle('is-up', !en.isIntersecting && en.boundingClientRect.top < 0);
            });
          },
          { threshold: 0 }
        ).observe(anchor);

        var stickyBtn = sticky.querySelector('[data-cx-sticky-add]');
        if (stickyBtn) {
          stickyBtn.addEventListener('click', function () {
            anchor.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
            var s = pdp.querySelector('[data-cx-opt="size"][aria-pressed="true"]');
            if (s && form) {
              form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
            } else {
              say('Pick a size first', 'error');
            }
          });
        }
      }

      render();
    });
  }

  // Delegate to the cart layer, which owns the drawer.
  function refreshCart() {
    if (window.CXCart) {
      window.CXCart.refresh(true).then(function () { window.CXCart.open(); });
      return;
    }
    // Cart layer missing: at least keep the badge honest.
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var fresh = new DOMParser()
          .parseFromString(d['cart-icon-bubble'], 'text/html')
          .querySelector('#cart-icon-bubble');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- product detail accordions ---------- */
  function initAcc(root) {
    root.querySelectorAll('[data-cx-acc]').forEach(function (group) {
      if (group.dataset.cxReady) return;
      group.dataset.cxReady = '1';
      group.querySelectorAll('.cx-acc__btn').forEach(function (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        if (btn.getAttribute('aria-expanded') === 'true') {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!open));
          panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
        });
      });
    });
  }

  /* ---------- size guide modal ---------- */
  function initModal(root) {
    root.querySelectorAll('[data-cx-modal]').forEach(function (modal) {
      if (modal.dataset.cxReady) return;
      modal.dataset.cxReady = '1';
      var id = modal.id;
      var opener = document.querySelector('[data-cx-modal-open="' + id + '"]');
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = modal.querySelector('.cx-modal__close');
        if (close) close.focus();
      }
      function close() {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }

      if (opener) opener.addEventListener('click', open);
      modal.querySelectorAll('[data-cx-modal-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });
  }

  function boot(root) {
    root = root || document;
    initPdp(root);
    initAcc(root);
    initModal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
